<main data-aos="fade-in">

    <h1 i18n="@@contact-title">Get in Touch</h1>
    <div class="content">
        <div class="info">
            <p i18n="@@contact-first"><span>F</span>eel free to contact me if you have any questions regarding my work.
                <p i18n="@@contact-second">
                    If you are interested in buying a painting, organizing an exhibition, or simply want to get in
                    touch, please fill out
                    this form.
                </p>
                <p i18n="@@contact-third">I will do my best to answer you within 24 hours.</p>

        </div>
        <div class="contact">

            <form [formGroup]="fg" (ngSubmit)="onSubmit(fg.value)" method="POST">
                <label for="name" i18n="@@name-contact">Name</label>
                <input nbInput type="text" formControlName="name" name="name">

                <label i18n="@@email-contact" for="email">Email</label>
                <input nbInput type="text" formControlName="email" name="email">
                <label i18n="@@message-contact" for="message">Message</label>
                <textarea name="message" id="" cols="30" rows="10" nbInput formControlName="message"></textarea>
                <button i18n="@@send-contact" type="submit" [disabled]="fg.invalid">Send</button>
            </form>
        </div>
    </div>
</main>